import { hashString } from 'lib/helpers';
import * as jsonpack from 'jsonpack';

const rawCaches = {};

export function unpackRawContent(
	packed,
	hash = hashString(String(packed)),
) {
	// already raw format
	if (typeof packed === 'object' && packed.blocks) {
		return packed;
	}

	if (typeof rawCaches[hash] !== 'undefined') {
		return rawCaches[hash];
	}

	let raw = packed;
	try {
		raw = jsonpack.unpack(packed);
		raw.sourceHash = hash;
	} catch (err) {
		console.warn('JSON Packed 格式解码失败，内容为：' + packed.substr(0, 100) + '...');
	}

	// 服务器不做缓存，否则容易内存泄漏
	if (typeof window !== 'undefined') {
		rawCaches[hash] = raw;
	}
	return raw || null;
}



// WEBPACK FOOTER //
// ./lib/helpers/unpackRawContent.js